module.exports = __webpack_public_path__ + "img/69.10.pH.f98b69f5.png";